import type { Step } from './channels'
import { channelLabel } from './channels'

/** One line for a read-only row: `3 steps on · Email, WhatsApp · up to 40 a day`. */
export function summariseFollowUps(steps: readonly Step[], dailyCap: number): string {
  const on = steps.filter((step) => step.enabled)
  const channels = [...new Set(on.map((step) => channelLabel(step.channel)))]
  const rungs =
    on.length === 0
      ? 'No steps on'
      : `${String(on.length)} ${on.length === 1 ? 'step' : 'steps'} on`
  const via = channels.length === 0 ? '' : ` · ${channels.join(', ')}`
  return `${rungs}${via} · up to ${String(dailyCap)} a day`
}
